import './listbuilder.less';
import { Setting } from '../objects/Setting';

angular.module("tromanWeb").controller('ListBuilderController',
    ['tromanServer', 'ObjectCache', '$scope', 'dialogService', 'downloadService', 'browserService', 'listService', 'ListConfiguration', 'list', 'definition', 'title',
        function (tromanServer, ObjectCache, $scope, dialogService, downloadService, browserService, listService, ListConfiguration, list, definition, title) {
    /// <param name="list" value="[]">The list of items to include</param>
    /// <param name="definition" value="{properties: [], title: '', settingType: 0 }">Definition from listService</param>
    var self = this;

    self.cfg = new ListConfiguration(definition);
    if (!angular.isUndefined(title))
        self.cfg.title = title;

    var defaultSetting = new Setting();
    defaultSetting.isDefault = true;
    defaultSetting.Id = 'DEFAULT_SETTING';
    defaultSetting.Name = "Standardmall";
    defaultSetting.title = "Standardmall";
    defaultSetting.Value = self.cfg.store();
    defaultSetting.SettingType = definition.settingType;

    self.template = defaultSetting;
    self.templates = [defaultSetting];
    self.editTemplate = defaultSetting.clone();

    ObjectCache.getSettings({
        IncludeShared: true,
        SettingType: definition.settingType
    }).then(function (data) {
        self.templates = [defaultSetting].concat(data);
        self.template = defaultSetting;
    }).catch(dialogService.error);

    self.templateChanged = function templateChanged() {
        if (self.template != null) {
            if (self.template.Value != null) {
                self.cfg.load(self.template.Value);
            }
            self.editTemplate = self.template.clone();
            if (self.editTemplate.SharedBy != null) {
                self.editTemplate.IsPublic = false;
            }
        }
    };

    function templateStored(rsp) {
        const setting = rsp.result;
        var pos = self.templates.findIndex(function (x) { return x.Id === setting.Id; });
        if (pos < 0) {
            self.templates.push(setting);
        } else {
            self.templates[pos] = setting;
            self.templates = self.templates.slice();
        }
        self.template = setting;
        self.templateChanged();
    }

    function isNameDuplicate(tpl, isAdding) {

        var newName = tpl.Name.trim().toLocaleLowerCase();
        var sameName = self.templates.findIndex(function (x) {
            if (x.SharedBy != null)
                return false;
            if (!isAdding && angular.isString(x.Id) && x.Id === tpl.Id)
                return false;
            return x.Name.toLocaleLowerCase() === newName;
        });

        return sameName >= 0;
    }

    self.canUpdate = function canUpdate() {
        if (self.templateForm.$invalid)
            return false;
        if (self.editTemplate.SharedBy != null)
            return false;
        if (self.editTemplate.isDefault)
            return false;
        return true;
    };

    self.saveTemplate = function saveTemplate() {
        if (!self.canUpdate())
            return;
        if (isNameDuplicate(self.editTemplate, false)) {
            dialogService.error("Namnet används redan.");
            return;
        }

        self.editTemplate.Value = self.cfg.store();
        tromanServer.Settings.updateEntity(self.editTemplate).then(templateStored).catch(dialogService.error);
    };

    self.canAdd = function canAdd() {
        if (self.templateForm.$invalid)
            return false;
        return true;
    };

    self.addTemplate = function addTemplate() {
        if (!self.canAdd())
            return;
        if (isNameDuplicate(self.editTemplate, true)) {
            dialogService.error("Namnet används redan.");
            return;
        }

        self.editTemplate.Id = undefined;
        self.editTemplate.Value = self.cfg.store();
        tromanServer.Settings.addEntity(self.editTemplate).then(templateStored).catch(dialogService.error);
    };

    self.canRemove = function canRemove() {
        if (self.template == null)
            return false;
        if (self.template.Id == null)
            return false;
        if (self.template.isDefault)
            return false;
        if (self.template.SharedBy != null)
            return false;
        return true;
    };

    self.removeTemplate = function removeTemplate() {
        if (!self.canRemove()) return;

        var confirmMsg = 'Radera mallen';
        if (self.template.IsPublic) {
            confirmMsg = confirmMsg + ', den är delad av dig och kommer inte heller finnas kvar för andra användare.';
        }
        dialogService.confirm([confirmMsg, 'Är du säker?']).then(function () {
            var id = self.template.Id;
            tromanServer.Settings.hardRemove(id).then(function () {
                self.templates = self.templates.filter(function (x) {
                    return x.Id !== id;
                });
                self.template = defaultSetting;
                self.templateChanged();
            }).catch(dialogService.error);
        });
    };

    self.cancel = function cancel() {
        $scope.$dismiss("cancelled");
    };

    self.saveExcel = function saveExcel() {
        var csv = listService.toCsv(list, self.cfg);
        downloadService.downloadText(csv, self.cfg.title + ".csv", "text/csv");
    };

    self.showPreview = function showPreview() {
        var pars = {
            title: self.cfg.title,
            content: listService.render(list, self.cfg)
        };
        browserService.openChildWindow('../print/print.html', 'printWindow', pars);
    };
}]);
